module.exports = __webpack_public_path__ + "static/media/LinkedFieldTermsOfUse004.208df85a.png";